// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListGridContainerStyle } from "@steiner/App/Components/Product/ProductListGridContainer";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productListGridContainerStyle.container = {
    css: css`
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;

        & > .bottom-section {
            margin-top: auto;
            display: flex;
            flex-direction: column;
            height: 100%;
            gap: 12px;
            padding-top: 8px;
            &:empty {
                display: none;
            }
        }

        ${xScreen("lte", "xs")} {
            max-width: 100%;
        }
    `,
};

productListGridContainerStyle.image = {
    css: css`
        position: relative;
        margin: 0 auto 8px;
    `,
};

productListGridContainerStyle.info = {
    css: css`
        display: flex;
        flex-direction: column;
        height: 100%;
    `,
};

productListGridContainerStyle.price = {
    css: css`
        margin-bottom: 4px;
    `,
};

productListGridContainerStyle.addToList = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        & > div:empty,
        &:empty,
        &:has(> div:empty) {
            display: none;
        }
    `,
};

productListGridContainerStyle.addToCartActions = {
    css: css`
        display: flex;
        & > div:empty,
        &:empty {
            display: none;
        }
    `,
};
